module.exports = __webpack_public_path__ + "img/008-avatar-6.a45d9420.png";